<template>
    <div class="warning-prompt text--orange mb-xl" :class="{'warning-prompt--simple' : simple, 'warning-prompt--small' : small}">
        <svg class="warning-prompt__icon icon"><use xlink:href="#alert" /></svg>
        <span class="warning-prompt__text text--orange small semi">
            {{ text }}
            <a v-if="link" @click="$emit('clicked')">{{ link }}</a>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            required: true,
        },
        simple: {
            type: Boolean,
            default: false,
        },
        small: {
            type: Boolean,
            default: false,
        },
        link: {
            type: String,
            default: null,
        }
    },
};
</script>
